import React, { Component } from "react";
import PropTypes from "prop-types";
import * as filterUtils from '../../lib/filterUtils';

class PortfolioFilter extends Component {
  constructor(props) {
    super(props);

    const statuses = [
      { label: "Renewal Eligible",  value: "renewal_eligible",  checked: true },
      { label: "Collections",       value: "collections",       checked: true },
      { label: "Paid in Full",      value: "paid_in_full",      checked: true },
      { label: "Open",              value: "open",              checked: true },
    ];

    const programs = [
      { label: "Starter",   value: "starter",   checked: true },
      { label: "Core",      value: "core",      checked: true },
      { label: "Standard",  value: "standard",  checked: true },
      { label: "Premium",   value: "premium",   checked: true },
      { label: "Low Risk",  value: "low risk",  checked: true },
      { label: "Legacy",    value: "legacy",    checked: true },
      { label: "Override",  value: "override",  checked: true },
    ];

    const types = [
      { label: "All Advances",      value: "all",     checked: true },
      { label: "Current Advances",  value: "current", checked: false },
    ];

    this.state = {
      currentDateRange: filterUtils.initialDateRange,   // date range of current showing data
      selectedDateRange: filterUtils.initialDateRange,  // date range going to be applied for next render
      dateRangePresets: filterUtils.dateRangePresets,
      shouldSelectCustomDateRange: true,
      shouldEditCustomDateRange: false,
      statuses, programs, types
    };

    // Bindings
    this.resetDateRange = filterUtils.resetDateRange.bind(this);
    this.resetStatuses = this.resetStatuses.bind(this);
    this.resetPrograms = this.resetPrograms.bind(this);
    this.resetTypes = this.resetTypes.bind(this);
    this.resetAll = this.resetAll.bind(this);
    this.setDateRangeFromPreset = filterUtils.setDateRangeFromPreset.bind(this);
    this.toggleStatus = this.toggleStatus.bind(this);
    this.toggleProgram = this.toggleProgram.bind(this);
    this.toggleType = this.toggleType.bind(this);
    this.getDateRangeSectionHTML = filterUtils.getDateRangeSectionHTML.bind(this);
    this.applyFilters = filterUtils.applyFilters.bind(this);
    this._resetFilterSectionOfCheckboxVals = filterUtils.resetFilterSectionOfCheckboxVals.bind(this);
    this._toggleFilterItemOfCheckboxVal = filterUtils.toggleFilterItemOfCheckboxVal.bind(this);
    this._toggleFilterItemOfRadioVal = filterUtils.toggleFilterItemOfRadioVal.bind(this);

    // Refs
    this.refBtnApplyFilters = React.createRef();
  }

  resetStatuses(searchImmediately = false) {
    this._resetFilterSectionOfCheckboxVals('statuses', searchImmediately);
  }

  resetPrograms(searchImmediately = false) {
    this._resetFilterSectionOfCheckboxVals('programs', searchImmediately);
  }

  resetTypes(searchImmediately = false) {
    const types = this.state.types.map(t => t.value === 'all' ? { ...t, checked: true } : { ...t, checked: false });
    this.setState({ types }, () => {
      if (searchImmediately){
        this.applyFilters();
      }
    });
  }

  resetAll() {
    this.resetDateRange();
    this.resetStatuses();
    this.resetPrograms();
    this.resetTypes(true);
  }

  /**
   * @param {Object} status Refer to definition of `state.statuses` for shape of status object
   */
  toggleStatus(status) {
    this._toggleFilterItemOfCheckboxVal(status, 'statuses');
  }

  /**
   * @param {Object} program Refer to definition of `state.programs` for shape of program object
   */
  toggleProgram(program) {
    this._toggleFilterItemOfCheckboxVal(program, 'programs');
  }

  /**
   * @param {Object} type Refer to deinition of `state.types` for shape of type object
   */
  toggleType(type) {
    this._toggleFilterItemOfRadioVal(type, 'types');
  }

  getAppliedFilters() {
    const statuses = this.state.statuses.filter(s => s.checked).map(s => s.value);
    const programs = this.state.programs.filter(p => p.checked).map(p => p.value);
    const type = this.state.types.find(t => t.checked).value;

    return {
      start_date: this.state.selectedDateRange.start.format(filterUtils.dateISOFormat),
      end_date: this.state.selectedDateRange.end.format(filterUtils.dateISOFormat),
      portfolio_statuses: statuses.length > 0 ? statuses : null,
      programs: programs.length > 0 ? programs : null,
      type
    };
  }

  render() {
    const dateRangeSectionHTML = this.getDateRangeSectionHTML();
    const FilterHeaderHTML = filterUtils.FilterHeaderHTML;
    const SectionHeader = filterUtils.SectionHeader;
    const SectionBody = filterUtils.SectionBody;
    return (
      <React.Fragment>
        <div className="filter-container">
          <FilterHeaderHTML resetAll={this.resetAll} />
          {dateRangeSectionHTML}
          <div className="section">
            <SectionHeader title="Status" />
            <SectionBody title="Status" controlType="checkbox" state={this.state.statuses} toggleFunc={this.toggleStatus} />
          </div>
          <div className="section">
            <SectionHeader title="Program" />
            <SectionBody title="Program" controlType="checkbox" state={this.state.programs} toggleFunc={this.toggleProgram} />
          </div>
          <div className="section">
            <SectionHeader title="Type" />
            <SectionBody title="Type" controlType="radio" state={this.state.types} toggleFunc={this.toggleType} />
          </div>
        </div>
        <a ref={this.refBtnApplyFilters} className="button is-block is-primary md-apply-filters" onClick={this.applyFilters}>Done</a>
      </React.Fragment>
    );
  }
}

PortfolioFilter.propTypes = {
  applyFilters: PropTypes.func,
};

export default PortfolioFilter;
